module.exports = __webpack_public_path__ + "img/統計学入門_7_5_問題.a6fdc273.png";